import reviews from "../../data/Reviews.json";

export const requestGetReviews = async () => {
  return reviews;
};
